import React from 'react'
import StaticTextComponent from './StaticTextComponent'
import BaseInputComponent from './BaseInputComponent'
import {Typeahead} from 'react-bootstrap-typeahead'
import {t} from '../../helpers/translate'

class TypeaheadComponent extends BaseInputComponent {

  constructor(props) {
    super(props);
    this.state = {
      saleChannels: [
        {'key': t('Phone'), 'value': 'phone'},
        {'key': t('Email'), 'value': 'email'},
        {'key': t('Mail'), 'value': 'mail'},
        {'key': t('Walk-In'), 'value': 'walkin'}
      ]
    };
  }

  getKey(value){
    return value ? this.state.saleChannels.filter(function(channel){return channel.value == value}, this)[0].key : ''
  }

  render() {
    return ((this.props.isStatic || this.getValue() == 'online') ?
              <StaticTextComponent id={this.props.id} value={this.getValue()}/> :
              <Typeahead
                bsSize='sm'
                className='salesChannelList'
                filterBy={(option, text) => option}
                labelKey={saleChannel => `${saleChannel.key}`}
                onChange={(selected) => this.handleChange(selected[0].value)}
                options={this.state.saleChannels}
                defaultInputValue={this.getKey(this.getValue())}
                placeholder={t('Required')}
              />
            )
  }
}

export default TypeaheadComponent;


// WEBPACK FOOTER //
// ./src/components/common/TypeaheadComponent.js